// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { del } from '@tls/auth';
import { useCallback, useState } from 'react';

export default function useProjectModelResetApi() {
  const [loading, setLoading] = useState(false);
  const [statusCode, setStatusCode] = useState(200);

  const resetModel = useCallback(async (projectId: string) => {
    setLoading(true);

    const { data, status, statusText } = await del(`projects/${projectId}/models`);
    setLoading(false);
    setStatusCode(status);
    return { data, status, statusText };
  }, []);

  return { resetModel, loading, statusCode };
}
